import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Button from 'react-bootstrap/Button';



import { geolocationValidationSchema } from '../../validations-modules/geoLocation.js'
import { FieldsGeolocation } from '../fields-common/FieldsGeolocation.js'

export const FormGeolocation = ({  formData, setFormData}) => {

  if ((formData === null) || (formData === undefined) || (formData.place === null) || (formData.place === undefined)) return <p>Loading...</p>

  return (
    <>
      <Formik
        initialValues={formData}
        enableReinitialize={true}
        onSubmit={(values, {setSubmitting, resetForm}) => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            setSubmitting(true);
            

            setFormData(prev => {
              return {...prev, ...values, 
                submitCount: prev.submitCount+1}
            });

            // Resets form after submission is complete
            resetForm();

            // Sets setSubmitting to false after form is reset
            setSubmitting(false);


        }}

        validationSchema={geolocationValidationSchema}>
        {({ isSubmitting, errors, touched, values, resetForm, handleSubmit, setFieldValue, setFieldTouched }) => 
        (
          <FieldsGeolocation  handleSubmit={handleSubmit} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched}>
                {touched.location === true && 
                (
                  <div>
                  <Button
                    type='submit'
                    variant='primary'
                    disabled={isSubmitting}
                    className="mr-1">
                    Salva
                  </Button>
                  <Button
                    type='button'
                    variant='primary'
                    onClick={() => resetForm()}
                    disabled={isSubmitting}
                    className="mr-1">
                    Annulla
                  </Button>
                  </div>  

                )
                }
          </FieldsGeolocation>
        )}
      </Formik>
    </>
  );
};

FormGeolocation.propTypes = {
  formData: PropTypes.object,
  setFormData: PropTypes.func.isRequired
};